import React, { useState } from "react";
import { Modal, ModalClose } from "@coverme/elements";
import { CTA } from "@coverme/forms";
import { getFormattedName } from "../../services/stringService";
import moment from "moment";
import { isCallCenterUser } from "../../services/userService";
import { displayLastFourDigitsSsn } from "../../services/ssnMasker";

const PersonItem = ({ person, onSubmitClicked, shouldShowSubmit = true }) => {
    const x = person;
    return (
        <div
            className="row"
            id={`person_${x.globalId}`}
            data-name={getFormattedName(x.firstName, x.middleName, x.lastName, x.suffix)}
            data-dob={moment(x.dateOfBirth).format("MM-DD-YYYY")}
            data-ssn={x.socialSecurityNumber || "N/A"}
        >
            <div className="person" key={x.globalId}>
                <h4>{getFormattedName(x.firstName, x.middleName, x.lastName, x.suffix)}</h4>
                <div className="details">
                    <div className="detail-item">MRN: {x.mrn || "N/A"}</div>
                    <div className="detail-item">SSN: {displayLastFourDigitsSsn(x.socialSecurityNumber) || "N/A"}</div>
                    <div className="detail-item">DOB: {moment(x.dateOfBirth).format("MM-DD-YYYY")}</div>
                </div>
            </div>
            {shouldShowSubmit && (
                <div className="action-button">
                    <CTA styleType="blue-alt" click={onSubmitClicked}>
                        Select
                    </CTA>
                </div>
            )}
        </div>
    );
};

const PersonMatchContent = ({ onSelect, persons, user }) => {
    return (
        <>
            <p>
                {persons?.length > 0
                    ? "Possible matches based on provided information"
                    : "No matches based on provided information"}
            </p>
            {isCallCenterUser(user) && persons.length > 0 && (
                <p>Please select the correct patient to begin the interview, otherwise please start a new case.</p>
            )}
            <div className="persons">
                {persons?.map(x => (
                    <PersonItem person={x} onSubmitClicked={onSelect.bind(this, x)} />
                ))}
                <div className="row" id="person_nomatch">
                    <div className="person">
                        <h4>{persons?.length > 0 && <>None of the above. Start a new case.</>}</h4>
                        <h4>{(persons == null || persons.length === 0) && <>No matches found. Start a new case.</>}</h4>
                    </div>
                    <div className="action-button">
                        <CTA styleType="blue-alt" click={onSelect?.bind(this, null)}>
                            Select
                        </CTA>
                    </div>
                </div>
            </div>
        </>
    );
};

const PersonVerifyContent = ({ selectedPerson, user, onBack, onStartNow, onSaveForLater }) => {
    return (
        <>
            <p>Please verify that this is the case you would like to update.</p>
            <PersonItem person={selectedPerson} shouldShowSubmit={false} />
            <div className="actions">
                <CTA styleType="grey-dark-alt" click={onBack}>
                    Go Back
                </CTA>
                <CTA styleType="blue-alt" click={onSaveForLater}>
                    Save For Later
                </CTA>
                {!isCallCenterUser(user) && (
                    <CTA styleType="blue" click={onStartNow}>
                        Start Now
                    </CTA>
                )}
            </div>
        </>
    );
};

export const PersonMatchModal = ({ isShown, onClose, onNoMatchFound, persons, history, onPersonVerify, user }) => {
    const [selectedPerson, setSelectedPerson] = useState(null);
    const onPersonSelect = selectedPerson => {
        if (selectedPerson === null) {
            onNoMatchFound();
        }

        setSelectedPerson(selectedPerson);
    };

    function onPersonVerifyImpl(shouldStartNow) {
        onPersonVerify(shouldStartNow, selectedPerson.globalId);
    }

    return (
        <Modal hide={onClose} isShowing={isShown} className="person-match-modal">
            <div className="modal-title">
                <h3>{selectedPerson == null ? "Possible Matches" : "Verify Match"}</h3>
                <ModalClose hide={onClose} showCloseButton={true} />
            </div>
            {selectedPerson == null && <PersonMatchContent persons={persons} onSelect={onPersonSelect} user={user} />}
            {selectedPerson != null && (
                <PersonVerifyContent
                    selectedPerson={selectedPerson}
                    user={user}
                    onBack={() => setSelectedPerson(null)}
                    onSaveForLater={onPersonVerifyImpl.bind(this, false)}
                    onStartNow={onPersonVerifyImpl.bind(this, true)}
                />
            )}
        </Modal>
    );
};
